import {register} from '../vendor/theme-scripts/theme-sections';
import accordion from '../features/accordion';
import tabs from '../features/tabs';

const sections = [];

class FaqTabs {
  constructor(section) {
    this.section = section
    this.id = section.id
    this.container = section.container
  }

  init() {
  }

  unload() {
  }

  onBlockSelect(evt) {
  }

  onBlockDeselect() {
  }
}

const faqTabs = {
  onLoad() {
    sections[this.id] = new FaqTabs(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
}

register('faq-tabs', [faqTabs, tabs, accordion]);
